import { useTranslation } from 'react-i18next';

import { ViewComponentProps } from '../../../common';
import { dateFormatter } from '../../../helpers/dates';
import { capitalize } from '../../../helpers/utils';

type StudentViewProps = ViewComponentProps & {
  student: any;
};

const StudentView: React.FC<StudentViewProps> = ({ student }) => {
  const { t } = useTranslation();
  return (
    <div className="student-view">
      <div className="ws-view-form">
        <div className="row">
          <label>{t('enrollments.studentView.student')}</label>
          <div className="value font-bold">{student.displayName}</div>
        </div>
        <div className="row">
          <label>{t('enrollments.studentView.dateOfBirth')}</label>
          <div className="value">{dateFormatter(student.birthday) || 'N/A'}</div>
        </div>
        <div className="row">
          <label>{t('enrollments.studentView.gender')}</label>
          <div className="value">{t(capitalize(student.gender)) || 'N/A'}</div>
        </div>
      </div>
    </div>
  );
};
export default StudentView;
